import { EldmlTransform } from "./EldmlTransform";

export class PdfTransform extends EldmlTransform {
  apply() {
    this.selector.find("pdf").each((_, element) => {
      this.transformer.processPdf(element);
    });
  }
}
